import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {ADialogState} from '@mintdata-wsp/common/state/DialogsState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {AddDesignDialog} from '@mintdata-wsp/wsp/ui/dialogs/AddDesignDialog';
import {AddOrganizationDialog} from '@mintdata-wsp/wsp/ui/dialogs/AddOrganizationDialog';
import {AddSpaceDialog} from '@mintdata-wsp/wsp/ui/dialogs/AddSpaceDialog';
import {ConfirmButtonSet, ConfirmDialog, IConfirmDialogProps} from '@mintdata-wsp/wsp/ui/dialogs/ConfirmDialog';
import {DeleteDialog} from '@mintdata-wsp/wsp/ui/dialogs/DeleteDialog';
import {NameCurrentVersionDialog} from '@mintdata-wsp/wsp/ui/dialogs/NameCurrentVersionDialog';
import {EditProfileDialog} from '@mintdata-wsp/wsp/ui/dialogs/profile/EditProfileDialog';
import {PublishConfirmUrlChangeDialog} from '@mintdata-wsp/wsp/ui/dialogs/publish/PublishConfirmUrlChangeDialog';
import {PublishDialog} from '@mintdata-wsp/wsp/ui/dialogs/publish/PublishDialog';
import {RenameDialog} from '@mintdata-wsp/wsp/ui/dialogs/RenameDialog';
import {TextInputDialog} from '@mintdata-wsp/wsp/ui/dialogs/TextInputDialog';
import {FlowRunWithParametersDialog} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/dialogs/FlowRunWithParametersDialog';
import {ClipboardHintDialog} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/dialogs/ClipboardHintDialog';
import {JoinForm} from '@mintdata-wsp/wsp/ui/views/workspace/auth/JoinForm';
import {LoginForm} from '@mintdata-wsp/wsp/ui/views/workspace/auth/LoginForm';
import {NewPasswordForm} from '@mintdata-wsp/wsp/ui/views/workspace/auth/NewPasswordForm';
import {ResetPasswordForm} from '@mintdata-wsp/wsp/ui/views/workspace/auth/ResetPasswordForm';
import {SignupForm} from '@mintdata-wsp/wsp/ui/views/workspace/auth/SignupForm';
import {InvoiceDetailsDialog} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/invoices/InvoiceDetailsDialog';
import {CreditCardEntryDialog} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/paymentMethod/CreditCardEntryDialog';
import {ProductSelectionDialog} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/plans/ProductSelectionDialog';
import {Window} from '@mintdata/mint-kit/impl/components/popover/Window';
import {action} from 'mobx';
import * as React from 'react';

export enum Dialogs
{
    AddOrganization = 1,
    AddSpace = 2,
    Confirm = 3,
    LoginForm = 4,
    SignUpForm = 5,
    ResetPasswordForm = 6,
    ProductSelection = 7,
    CreditCardEntry = 8,
    Publish = 9,
    TextInput = 10,
    EditProfile = 11,
    NewPasswordForm = 12,
    JoinForm = 13,
    InvoiceDetails = 14,
    FlowRunWithParameters = 15,
    ClipboardHint = 16,
    ImportTabs = 17,
    NameCurrentVersion = 18,
    Delete = 19,
    Rename = 20,
    AddDesign = 21,
    PublishConfirmUrlChange = 22,
}

export class DialogsController
{
    public renderAllPublic()
    {
        return <div>
            {this._renderDialog(LoginForm, rootState.ui.dialogs.loginForm)}
            {this._renderDialog(SignupForm, rootState.ui.dialogs.signupForm)}
            {this._renderDialog(ResetPasswordForm, rootState.ui.dialogs.resetPasswordForm)}
            {this._renderDialog(NewPasswordForm, rootState.ui.dialogs.newPasswordForm)}
            {this._renderDialog(JoinForm, rootState.ui.dialogs.joinForm)}
        </div>;
    }

    public renderAll()
    {
        return <div>
            {this._renderDialog(AddOrganizationDialog, rootState.ui.dialogs.addOrganization)}
            {this._renderDialog(AddSpaceDialog, rootState.ui.dialogs.addSpace)}
            {this._renderDialog(AddDesignDialog, rootState.ui.dialogs.addDesign)}
            {this._renderDialog(ConfirmDialog, rootState.ui.dialogs.confirm)}
            {this._renderDialog(ProductSelectionDialog, rootState.ui.dialogs.productSelection)}
            {this._renderDialog(CreditCardEntryDialog, rootState.ui.dialogs.creditCardEntry)}
            {this._renderDialog(PublishDialog, rootState.ui.dialogs.publish)}
            {this._renderDialog(PublishConfirmUrlChangeDialog, rootState.ui.dialogs.publishConfirmUrlChange)}
            {this._renderDialog(TextInputDialog, rootState.ui.dialogs.textInput)}
            {this._renderDialog(EditProfileDialog, rootState.ui.dialogs.editProfile)}
            {this._renderDialog(InvoiceDetailsDialog, rootState.ui.dialogs.invoiceDetails)}
            {this._renderDialog(FlowRunWithParametersDialog, rootState.ui.dialogs.flowRunWithParameters)}
            {this._renderDialog(ClipboardHintDialog, rootState.ui.dialogs.clipboardHint)}
            {this._renderDialog(ClipboardHintDialog, rootState.ui.dialogs.clipboardHint)}
            {/*{this._renderDialog(ImportTabsDialog, rootState.ui.dialogs.importTabs)}*/}
            {this._renderDialog(NameCurrentVersionDialog, rootState.ui.dialogs.nameCurrentVersion)}
            {this._renderDialog(DeleteDialog, rootState.ui.dialogs.delete)}
            {this._renderDialog(RenameDialog, rootState.ui.dialogs.rename)}
        </div>;
    }

    private _renderDialog(DialogComponent:React.ComponentClass, dialogState:ADialogState)
    {
        if( !dialogState.isVisible )
            return null;

        const {popupId, isModal, currentProps, hasModalBackground, ignoreEsc} = dialogState;

        return <Window id={popupId}
                       isModal={isModal}
                       hasModalBackground={hasModalBackground}
                       ignoreEsc={ignoreEsc}
                       onDismissed={action(() =>
                       {
                           dialogState.isVisible = false;
                       })}>

            {currentProps ? <DialogComponent {...currentProps} /> : <DialogComponent />}

        </Window>;
    }

    @action.bound
    public showDangerConfirm(title:string, content:string|JSX.Element, onConfirmed:(data:any) => void | Promise<void>, buttonSet?:ConfirmButtonSet | string[]):void
    {
        controllers.ui.dialogs.showConfirmDialog({
            intent: MDIntent.Danger,
            title,
            content,
            buttonSet,
            onConfirmed,
        });
    }

    @action.bound
    public showDangerReload(title:string, content:string, onConfirmed:(data:any) => void | Promise<void>, icon = MDIcons.common.QuestionMark):void
    {
        controllers.ui.dialogs.showConfirmDialog({
            title,
            content,
            buttonSet: ConfirmButtonSet.DISMISS_RELOAD,
            onConfirmed,
        });
    }

    @action.bound
    public hideConfirmDialog():void
    {
        this._updateState(Dialogs.Confirm, false, null);
    }

    @action.bound
    public showConfirmDialog(req:IConfirmDialogProps):void
    {
        this._updateState(Dialogs.Confirm, true, req);
    }

    @action.bound
    public showDialog(dialogId:Dialogs, isModal:boolean = true, props:any = null):void
    {
        this._updateIsModal(dialogId, isModal);
        this._updateState(dialogId, true, props);
    }

    @action.bound
    public hideDialog(dialogId:Dialogs):void
    {
        this._updateState(dialogId, false, null);
    }

    @action.bound
    public hideAll():void
    {
        for( let key in Dialogs )
        {
            const dialogId = parseInt(key);

            if( !isNaN(dialogId) )
                this.hideDialog(dialogId);
        }
    }

    private _updateIsModal(dialogId:Dialogs, isModal:boolean)
    {
        const dialogState = this.getDialogState(dialogId);
        dialogState.isModal = isModal;
    }

    private _updateState(dialogId:Dialogs, isVisible:boolean, props:any)
    {
        const dialogState = this.getDialogState(dialogId);

        dialogState.currentProps = props;
        dialogState.isVisible = isVisible;
    }

    private getDialogState(dialogId:Dialogs):ADialogState
    {
        switch( dialogId )
        {
            case Dialogs.AddOrganization:
                return rootState.ui.dialogs.addOrganization;
            case Dialogs.AddSpace:
                return rootState.ui.dialogs.addSpace;
            case Dialogs.AddDesign:
                return rootState.ui.dialogs.addDesign;
            case Dialogs.Confirm:
                return rootState.ui.dialogs.confirm;
            case Dialogs.LoginForm:
                return rootState.ui.dialogs.loginForm;
            case Dialogs.SignUpForm:
                return rootState.ui.dialogs.signupForm;
            case Dialogs.ResetPasswordForm:
                return rootState.ui.dialogs.resetPasswordForm;
            case Dialogs.ProductSelection:
                return rootState.ui.dialogs.productSelection;
            case Dialogs.CreditCardEntry:
                return rootState.ui.dialogs.creditCardEntry;
            case Dialogs.Publish:
                return rootState.ui.dialogs.publish;
            case Dialogs.PublishConfirmUrlChange:
                return rootState.ui.dialogs.publishConfirmUrlChange;
            case Dialogs.TextInput:
                return rootState.ui.dialogs.textInput;
            case Dialogs.EditProfile:
                return rootState.ui.dialogs.editProfile;
            case Dialogs.NewPasswordForm:
                return rootState.ui.dialogs.newPasswordForm;
            case Dialogs.JoinForm:
                return rootState.ui.dialogs.joinForm;
            case Dialogs.InvoiceDetails:
                return rootState.ui.dialogs.invoiceDetails;
            case Dialogs.FlowRunWithParameters:
                return rootState.ui.dialogs.flowRunWithParameters;
            case Dialogs.ClipboardHint:
                return rootState.ui.dialogs.clipboardHint;
            case Dialogs.ImportTabs:
                return rootState.ui.dialogs.importTabs;
            case Dialogs.NameCurrentVersion:
                return rootState.ui.dialogs.nameCurrentVersion;
            case Dialogs.Delete:
                return rootState.ui.dialogs.delete;
            case Dialogs.Rename:
                return rootState.ui.dialogs.rename;
            default:
                throw new Error(`Unknown dialogId: ${dialogId}`);
        }
    }
}
